"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateExistingKpiWidget = exports.validateExistingInsightWidget = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
var general_1 = require("../../../events/general");
/**
 * Given list of all dashboard widgets and a command that contains a ref, this function tests that the `ref` is
 * a reference to an existing dashboard widget and that the existing widget is an insight widget.
 *
 * If the validation succeeds, the located insight widget will be returned. Otherwise an error will fly. The error
 * will be an instance of DashboardCommandFailed event - it can be propagated through the command handler all the
 * way to the root command handler saga.
 *
 * @param ctx - dashboard context, this will be included in the DashboardCommandFailed event
 * @param widgets - map of widgets on the dashboard
 * @param cmd - any command that has 'ref' in its payload
 */
function validateExistingInsightWidget(widgets, cmd, ctx) {
    var ref = cmd.payload.ref;
    var widget = widgets.get(ref);
    if (!widget) {
        throw general_1.invalidArgumentsProvided(ctx, cmd, "Cannot find insight widget with ref: " + sdk_model_1.serializeObjRef(ref) + ".");
    }
    if (!sdk_model_1.isInsightWidget(widget)) {
        throw general_1.invalidArgumentsProvided(ctx, cmd, "Widget with ref: " + sdk_model_1.serializeObjRef(ref) + " exists but is not an insight widget.");
    }
    return widget;
}
exports.validateExistingInsightWidget = validateExistingInsightWidget;
/**
 * Given list of all dashboard widgets and a command that contains a ref, this function tests that the `ref` is
 * a reference to an existing dashboard widget and that the existing widget is a KPI widget.
 *
 * If the validation succeeds, the located KPI widget will be returned. Otherwise an error will fly. The error
 * will be an instance of DashboardCommandFailed event - it can be propagated through the command handler all the
 * way to the root command handler saga.
 *
 * @param ctx - dashboard context, this will be included in the DashboardCommandFailed event
 * @param widgets - map of widgets on the dashboard
 * @param cmd - any command that has 'ref' in its payload
 */
function validateExistingKpiWidget(widgets, cmd, ctx) {
    var ref = cmd.payload.ref;
    var widget = widgets.get(ref);
    if (!widget) {
        throw general_1.invalidArgumentsProvided(ctx, cmd, "Cannot find insight widget with ref: " + sdk_model_1.serializeObjRef(ref) + ".");
    }
    if (!sdk_model_1.isKpiWidget(widget)) {
        throw general_1.invalidArgumentsProvided(ctx, cmd, "Widget with ref: " + sdk_model_1.serializeObjRef(ref) + " exists but is not a KPI widget.");
    }
    return widget;
}
exports.validateExistingKpiWidget = validateExistingKpiWidget;
//# sourceMappingURL=widgetValidations.js.map